import { formatDateTime } from '../utils/date';
import { formatPhone } from '../utils/validation';
import './Summary.css';

const Summary = ({ 
  service, 
  date, 
  time, 
  contactInfo, 
  onEdit,
  onBack,
  onConfirm, 
  loading = false 
}) => {
  return (
    <div className="summary-container">
      <div className="summary-card">
        {/* Zhrnutie rezervácie */}
        <div className="summary-section">
          <h3 className="section-title">Zhrnutie rezervácie</h3>
          
          <div className="summary-row">
            <div className="row-label">Služba</div>
            <div className="row-value">
              <span>{service?.nazov}</span>
              {onEdit && (
                <button onClick={() => onEdit('service')} className="edit-btn">Zmeniť službu</button>
              )}
            </div>
          </div>

          <div className="summary-row">
            <div className="row-label">Termín</div>
            <div className="row-value">
              <span>{formatDateTime(date, time)}</span>
              {onEdit && (
                <button onClick={() => onEdit('datetime')} className="edit-btn">Zmeniť dátum/čas</button>
              )}
            </div>
          </div>

          {service?.trvanie_minuty && (
            <div className="summary-row">
              <div className="row-label">Trvanie</div>
              <div className="row-value"><span>{service.trvanie_minuty} min</span></div>
            </div>
          )}

          {service?.cena && (
            <div className="summary-row">
              <div className="row-label">Cena</div>
              <div className="row-value"><span>{service.cena} €</span></div>
            </div>
          )}
        </div>

        {/* Kontaktné údaje */}
        <div className="summary-section">
          <h3 className="section-title">Kontaktné údaje</h3>
          
          <div className="summary-row">
            <div className="row-label">Meno</div>
            <div className="row-value">
              <span>{contactInfo?.cele_meno}</span>
              {onEdit && (
                <button onClick={() => onEdit('cele_meno')} className="edit-btn">Zmeniť meno</button>
              )}
            </div>
          </div>

          <div className="summary-row">
            <div className="row-label">Email</div>
            <div className="row-value">
              <span>{contactInfo?.email}</span>
              {onEdit && (
                <button onClick={() => onEdit('email')} className="edit-btn">Zmeniť email</button>
              )}
            </div>
          </div>

          <div className="summary-row">
            <div className="row-label">Telefón</div>
            <div className="row-value">
              <span>{formatPhone(contactInfo?.telefon)}</span>
              {onEdit && (
                <button onClick={() => onEdit('telefon')} className="edit-btn">Zmeniť telefón</button>
              )}
            </div>
          </div>

          <div className="summary-row">
            <div className="row-label">Adresa</div>
            <div className="row-value">
              <span style={{whiteSpace: 'pre-line'}}>{contactInfo?.adresa || '-'}</span>
              {onEdit && (
                <button onClick={() => onEdit('adresa')} className="edit-btn">Zmeniť adresu</button>
              )}
            </div>
          </div>

          {contactInfo?.poznamka && (
            <div className="summary-row">
              <div className="row-label">Poznámka</div>
              <div className="row-value">
                <span>{contactInfo.poznamka}</span>
                {onEdit && (
                  <button onClick={() => onEdit('poznamka')} className="edit-btn">Zmeniť</button>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="summary-actions">
          {onBack && (
            <button onClick={onBack} className="btn btn-secondary">
              Späť
            </button>
          )}
          <button
            onClick={onConfirm}
            disabled={loading}
            className="btn btn-primary"
          >
            {loading ? 'Spracúvam...' : 'Potvrdiť rezerváciu'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Summary;
